import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAppUpdate } from "@/hooks/useInstallPrompt";
import { cn } from "@/lib/cn";

export function UpdateNotification({ className }: { className?: string }) {
  const { updateAvailable, applyUpdate, dismissUpdate } = useAppUpdate();

  if (!updateAvailable) return null;

  return (
    <div
      className={cn(
        "fixed bottom-20 left-4 right-4 z-50 mx-auto max-w-md rounded-[var(--radius-xl)] border border-[var(--color-primary)]/20 bg-[var(--card)] p-4 shadow-lg",
        className,
      )}
      role="alert"
      aria-label="App update available"
    >
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[var(--radius-lg)] bg-[var(--color-primary-soft)]">
          <RefreshCw className="h-5 w-5 text-[var(--color-primary)]" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-[var(--foreground)]">
            Update available
          </h3>
          <p className="mt-0.5 text-xs text-[var(--muted-foreground)]">
            A new version of Carmel Work is ready. Reload to get the latest features.
          </p>
          <div className="mt-3 flex gap-2">
            <Button size="sm" className="h-8 text-xs" onClick={applyUpdate}>
              Update now
            </Button>
            <Button size="sm" variant="ghost" className="h-8 text-xs" onClick={dismissUpdate}>
              Later
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
